import {
  Button,
  Card,
  Confirm,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Tab,
} from 'semantic-ui-react';
import React, { Component } from 'react';

import AudioBlock from './pageBuilder/blocks/audio_block';
import ContentBlock from './pageBuilder/blocks/content_block';
import Details from './pageBuilder/details';
import EditoBlock from './pageBuilder/blocks/edito_block';
import ImageGalleryBlock from './pageBuilder/blocks/image_gallery_block';
import Images from './pageBuilder/images';
import InstagramBlock from './pageBuilder/blocks/instagram_block';
import IntroBlock from './pageBuilder/blocks/intro_block';
import Messages from '../Messages.js';
import PermissionsManager from '../PermissionsManager';
import PushBlock from './pageBuilder/blocks/push_block';
import PushFacebookBlock from './pageBuilder/blocks/push_facebook_block';
import ServicesBlock from './pageBuilder/blocks/services_block';
import SliderBlock from './pageBuilder/blocks/slider_block';
import TimeBlock from './pageBuilder/blocks/time_block';
import VideoGalleryBlock from './pageBuilder/blocks/video_gallery_block';
import ZoomBlock from './pageBuilder/blocks/zoom_block';
import { inlineStyle } from '../../styles/custom';
import { languages } from '../../constants';

const renderPanes = (obj, onChange) => {
  let panes = languages.map((language) => {
    const attrs = { obj: obj, language: language, onChange: onChange };
    return {
      menuItem: language.label,
      render: () => (
        <Tab.Pane key={language.code} attached={false}>
          <Details {...attrs} />
        </Tab.Pane>
      ),
    };
  });

  panes.push({
    menuItem: 'Gestion des images',
    render: () => (
      <Tab.Pane attached={false}>
        <Images obj={obj} onChange={onChange} />
      </Tab.Pane>
    ),
  });

  return panes;
};

const options = [
  {
    text: '---',
    value: null,
  },
  {
    text: 'Bloc introduction',
    value: 'intro_block',
  },
  {
    text: 'Bloc horaires',
    value: 'time_block',
  },
  {
    text: 'Bloc slider',
    value: 'slider_block',
  },
  {
    text: 'Bloc push',
    value: 'push_block',
  },
  {
    text: 'Bloc texte',
    value: 'content_block',
  },
  {
    text: 'Bloc services',
    value: 'services_block',
  },
  {
    text: 'Bloc Instagram',
    value: 'instagram_block',
  },
  {
    text: 'Bloc Zoom',
    value: 'zoom_block',
  },
  {
    text: 'Bloc Push Facebook',
    value: 'push_facebook_block',
  },
  {
    text: 'Bloc Edito',
    value: 'edito_block',
  },
  {
    text: 'Bloc Audio',
    value: 'audio_block',
  },
  {
    text: 'Bloc Galerie Vidéos',
    value: 'video_gallery_block',
  },
  {
    text: 'Bloc Galerie Images',
    value: 'image_gallery_block',
  },
];

class PageForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataBlocks: [],
      typeBlocks: [],
      currentTypeBlock: null,
      confirm: null,
      currentIndex: null,
    };
  }

  componentDidMount() {
    const { obj } = this.props;

    if (obj.blocks.length > 0) {
      const typeBlocks = [];
      for (const block of obj.blocks) {
        typeBlocks.push(block.type);
      }

      this.setState({
        dataBlocks: [...obj.blocks],
        typeBlocks,
      });
    }
  }

  /**
   * Add new bloc
   */
  handleClick = (e) => {
    e.preventDefault();
    if (!this.state.currentTypeBlock) {
      return;
    }

    const typeBlocks = [...this.state.typeBlocks, this.state.currentTypeBlock];
    this.renderBlocks(typeBlocks);

    this.setState({
      typeBlocks,
      currentTypeBlock: null,
    });
  };

  /**
   * Set current field
   */
  handleChange = (e, data) => {
    this.setState({
      currentTypeBlock: data.value,
    });
  };

  /**
   * Delete block item
   */
  handleDelete = (e, data) => {
    let newState = { ...this.state };

    switch (data.confirm) {
      case true:
        newState.confirm = true;
        newState.currentIndex = data.index;
        break;
      case null:
        newState.confirm = false;
        newState.currentIndex = null;
        break;
      case false:
        newState.typeBlocks.splice(data.index, 1);
        newState.dataBlocks.splice(data.index, 1);
        newState.confirm = null;
        newState.currentIndex = null;
        this.renderBlocks(newState.typeBlocks);
        break;
      default:
        break;
    }

    this.setState(newState);
  };

  /**
   * Move block
   *
   * @param string sort (up|down)
   * @param integer index
   */
  handleMoveBlock = (sort, index) => {
    const typeBlocks = [...this.state.typeBlocks];
    const dataBlocks = [...this.state.dataBlocks];

    if (sort === 'up') {
      if (index !== 0) {
        // Move type blocks
        let tmp = typeBlocks[index - 1];
        typeBlocks[index - 1] = typeBlocks[index];
        typeBlocks[index] = tmp;
        // Move data blocks
        tmp = dataBlocks[index - 1];
        dataBlocks[index - 1] = dataBlocks[index];
        dataBlocks[index] = tmp;
      }
    } else {
      if (index !== typeBlocks.length) {
        // Move type blocks
        let tmp = typeBlocks[index + 1];
        typeBlocks[index + 1] = typeBlocks[index];
        typeBlocks[index] = tmp;
        // Move data blocks
        tmp = dataBlocks[index + 1];
        dataBlocks[index + 1] = dataBlocks[index];
        dataBlocks[index] = tmp;
      }
    }

    this.renderBlocks(typeBlocks);

    this.setState({
      typeBlocks,
      dataBlocks,
    });
  };

  /**
   * Get values of blocks
   */
  getValues = () => {
    return this.state.typeBlocks.map((block, i) => {
      return this['block_' + i].getValues();
    });
  };

  /**
   * Return block by type
   */
  renderBlock = (type, i) => {
    const { dataBlocks } = this.state;
    const obj = dataBlocks.length > 0 && dataBlocks[i] ? dataBlocks[i] : null;
    const key = Math.floor(Math.random() * 9999999) + 1;

    switch (type) {
      case 'intro_block':
        return (
          <IntroBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'slider_block':
        return (
          <SliderBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'push_block':
        return (
          <PushBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'content_block':
        return (
          <ContentBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'time_block':
        return (
          <TimeBlock
            key={key}
            obj={obj}
            places={this.props.places}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'services_block':
        return (
          <ServicesBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'instagram_block':
        return (
          <InstagramBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'zoom_block':
        return (
          <ZoomBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'push_facebook_block':
        return (
          <PushFacebookBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'edito_block':
        return (
          <EditoBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'audio_block':
        return (
          <AudioBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'video_gallery_block':
        return (
          <VideoGalleryBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      case 'image_gallery_block':
        return (
          <ImageGalleryBlock
            key={key}
            obj={obj}
            onMoveBlock={this.handleMoveBlock}
            index={i}
            max={this.state.typeBlocks.length}
            onDelete={(e) => {
              this.handleDelete(e, { confirm: true, index: i });
            }}
            ref={(ref) => (this['block_' + i] = ref)}
          />
        );
      default:
        return null;
    }
  };

  /**
   * Return all blocks
   */
  renderBlocks = (blocks) => {
    return blocks.map(this.renderBlock);
  };

  render() {
    const { typeBlocks } = this.state;
    const {
      obj,
      status,
      onChange,
      onSubmit,
      onDelete,
      errorOccuredWithPlaceId,
    } = this.props;

    return (
      <Form loading={status.loading}>
        <Header>
          Page builder{status.isNew ? ' : Création' : ' : Édition'}
        </Header>
        <Messages errors={status.errors} />
        <Form.Field>
          <Form.Input
            placeholder="Type"
            id="type"
            fluid
            label="Type"
            value={obj.type}
            onChange={onChange}
          />
        </Form.Field>
        <Form.Field>
          <label>
            Tags de mise en avant{' '}
            <em>(Exemple de multiple tags : tag1,tag2,tag3)</em>
          </label>
          <Form.Input
            placeholder="Tags"
            id="tags"
            fluid
            value={obj.tags}
            onChange={onChange}
          />
        </Form.Field>
        <Tab menu={{ pointing: true }} panes={renderPanes(obj, onChange)} />
        <br />
        {this.renderBlocks(typeBlocks)}
        <br />
        <Form.Field>
          <Card fluid>
            <Card.Content>
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column>
                    <Dropdown
                      placeholder="Sélectionnez un type de bloc"
                      selection
                      fluid
                      options={options}
                      id="block"
                      value={this.state.currentTypeBlock}
                      onChange={(e, data) => this.handleChange(e, data)}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <Button
                      color="blue"
                      fluid
                      onClick={(e) => {
                        this.handleClick(e);
                      }}
                    >
                      <Icon name="block layout" /> Ajouter un bloc
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Card.Content>
          </Card>
        </Form.Field>
        <br />
        <Form.Field>
          <PermissionsManager hasPermissions={['create_page', 'update_page']}>
            <Button disabled={status.loading} floated="left" onClick={onSubmit}>
              <Icon name="save" /> Sauvegarder
            </Button>
          </PermissionsManager>
          <PermissionsManager hasPermissions={['delete_page']}>
            {!status.isNew ? (
              <Button
                disabled={status.loading}
                color="red"
                floated="right"
                onClick={(e, data) => {
                  onDelete(e, { confirm: true });
                }}
              >
                <Icon name="delete" /> Suppression
              </Button>
            ) : null}
          </PermissionsManager>
        </Form.Field>
        {errorOccuredWithPlaceId ? (
          <p>Merci de selectionner un emplacement dans le bloc horaire.</p>
        ) : null}
        <Confirm
          content="Êtes-vous sûr(e) de vouloir supprimer cette page ? Cette action est définitive."
          open={status.deletion.confirm}
          onCancel={(page, data) => {
            onDelete(page, { confirm: null });
          }}
          onConfirm={(page, data) => {
            onDelete(page, { confirm: false });
          }}
          style={inlineStyle.modal}
          cancelButton="Annuler"
          confirmButton="Ok"
        />
        <Confirm
          content="Êtes-vous sûr(e) de vouloir supprimer ce bloc ? Cette action est définitive."
          open={this.state.confirm}
          onCancel={(e, data) => {
            this.handleDelete(e, {
              confirm: null,
              index: this.state.currentIndex,
            });
          }}
          onConfirm={(e, data) => {
            this.handleDelete(e, {
              confirm: false,
              index: this.state.currentIndex,
            });
          }}
          style={inlineStyle.modal}
          cancelButton="Annuler"
          confirmButton="Ok"
        />
      </Form>
    );
  }
}

export default PageForm;



// WEBPACK FOOTER //
// ./src/components/form/PageBuilder.js